import { InspectionStatusPipe } from './inspection.status.pipe';

export function InspectionStatusFilter ( inspectionStatusPipe : InspectionStatusPipe ) {
  return ( value : string ) : string => inspectionStatusPipe.transform(value);
};